import React from 'react';

export default function Facebook() {
  return (
    <svg
      width='25'
      height='25'
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='m16.149 21.878.004-6.966 2.333.002.351-2.708-2.682-.002.001-1.728c0-.784.22-1.319 1.343-1.318h1.434l.002-2.421a19 19 0 0 0-2.09-.109c-2.067-.001-3.483 1.26-3.484 3.578l-.002 1.996-2.338-.002-.002 2.709 2.338.001-.004 6.966-8.606-.006a1 1 0 0 1-1-1l.011-16a1 1 0 0 1 1-1l16 .011a1 1 0 0 1 1 1l-.01 16a1 1 0 0 1-1.001 1z'
        fill='currentColor'
      />
    </svg>
  );
}
